import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 20px;
`;

export const Header = styled.div`
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  padding: 20px 16px;
  color: white;
  display: flex;
  align-items: center;
  gap: 12px;

  button {
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
  }

  h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const PatientCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 16px 16px 0 16px;
  padding: 16px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

export const PatientAvatar = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  flex-shrink: 0;
`;

export const PatientInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const PatientNameText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PatientMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  span {
    font-size: 12px;
    color: #64748b;
    background: #f1f5f9;
    padding: 2px 8px;
    border-radius: 6px;
  }
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 4px;
`;

export const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Card = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CardHeader = styled.div`
  padding: 14px 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
`;

export const CardTitle = styled.span`
  font-size: 15px;
  font-weight: 600;
`;

export const CardBadge = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const CardBody = styled.div`
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
`;

export const CardLabel = styled.span`
  color: #64748b;
  font-weight: 500;
`;

export const CardValue = styled.span<{ highlight?: boolean }>`
  color: ${(props) => (props.highlight ? "#10b981" : "#1e293b")};
  font-weight: ${(props) => (props.highlight ? "700" : "600")};
  font-size: ${(props) => (props.highlight ? "16px" : "13px")};
`;

export const CardFooter = styled.div`
  padding: 10px 16px;
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  font-size: 12px;
  color: #3b82f6;
  font-weight: 600;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
  text-align: center;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #64748b;
  }

  span {
    font-size: 13px;
    color: #94a3b8;
    margin-top: 6px;
  }
`;

export const LoadingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
`;
